export const createMockStore = (initialState = {}) => {
  const mockStore = {
    getState: () => initialState,
    dispatch: action => {},
    subscribe: () => {},
  }

  return mockStore
}
